import React from "react";
import { formatShortDate } from "../shared/format";

/**
 * Enlèvements par jour sur 30 jours.
 *
 * Barres en CSS plutôt qu'une librairie de graphes : aucune n'est installée et
 * la stack (react-scripts 4 / Node 14) rend tout ajout risqué pour un rendu que
 * quelques div suffisent à produire.
 */
const DailyChart = ({ data = [], onSelectDay, t }) => {
  const max = Math.max(1, ...data.map((entry) => entry.count));
  const ticks = [0, 7, 14, 21, data.length - 1].filter(
    (index) => index >= 0 && index < data.length
  );

  return (
    <div className="mgr-card" style={{ padding: "22px 26px 18px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: 16,
          marginBottom: 18,
          flexWrap: "wrap",
        }}
      >
        <div className="mgr-card-title">{t("Opgehaalde bestellingen per dag")}</div>
        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--mgr-ink-3)" }}>
          {t("Laatste 30 dagen · klik op een dag om de lijst te filteren")}
        </div>
      </div>

      <div className="mgr-chart">
        {data.map((entry) => {
          const height = entry.count === 0 ? 4 : Math.max(8, (entry.count / max) * 120);
          const classes = [
            "mgr-chart-bar",
            entry.count === 0 ? "is-empty" : "",
            entry.isToday ? "is-today" : "",
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <button
              key={entry.date.toISOString()}
              type="button"
              className={classes}
              style={{ height }}
              title={`${formatShortDate(entry.date)} — ${entry.count}`}
              aria-label={`${formatShortDate(entry.date)}: ${entry.count}`}
              onClick={() => onSelectDay && onSelectDay(entry.date)}
            />
          );
        })}
      </div>

      <div className="mgr-chart-axis">
        {ticks.map((index) => (
          <span
            key={index}
            style={index === data.length - 1 ? { color: "var(--mgr-brand)" } : undefined}
          >
            {index === data.length - 1 ? t("vandaag") : formatShortDate(data[index].date)}
          </span>
        ))}
      </div>
    </div>
  );
};

export default DailyChart;
